<template>
    <div>
        <!-- Modal -->
        <!--
        <div class="modal fade" id="repetirAgendaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="dados">
                    <div class="modal-header">
                        <h5 class="modal-title">Recorrência...</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        -->
                        <div class="row mt-3">
                            <div class="col col-12" :class="coluna_unica ? '' : 'col-md-4'">
                                <az-input
                                    label="Repetir a cada"
                                    type="number"
                                    v-model="dados.intervalo">
                                    <template v-slot:button-pos>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">
                                                {{ dados.intervalo > 1 ? 'semanas' : 'semana' }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>                   
                            </div>
                            <div class="col col-12 d-flex flex-column" :class="coluna_unica ? '' : 'col-md-8'">
                                <small class="text-muted">Repetir</small>
                                <div class="btn-group" role="group">
                                    <button type="button" class="btn" 
                                        :class="dia.selecionado ? 'btn-secondary' : 'btn-outline-secondary'" 
                                        @click="dia.selecionado = !dia.selecionado"
                                        v-for="(dia, idia) in dados.dias" :key="idia">
                                        {{ dia.nome }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12" :class="coluna_unica ? '' : 'col-md-4'">
                                <small class="text-muted">Terminar em</small>
                                <az-input
                                    type="date"
                                    v-model="dados.termina_em"
                                    :edicao="dados.fim == 'em'">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <input type="radio" v-model="dados.fim" value="em">
                                                <span class="ml-2">Em &nbsp;&nbsp;</span>
                                            </div>
                                        </div>
                                    </template>
                                </az-input>
                                <az-input
                                    type="number"
                                    :max="60"
                                    :maxlength="2"
                                    v-model="dados.ocorrencias"
                                    :edicao="dados.fim == 'apos'">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <input type="radio" v-model="dados.fim" value="apos">
                                                <span class="ml-2">Após</span>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:button-pos>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">
                                                {{ dados.ocorrencias > 1 ? 'ocorrências' : 'ocorrência' }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12" :class="coluna_unica ? '' : 'col-md-8'">
                                <div class="d-flex justify-content-between">
                                    <small class="text-muted">Datas</small>
                                    <div class="badge badge-success">
                                        {{ total_datas() }}
                                    </div>
                                </div>
                                
                                <div class="alert alert-primary">
                                    <div class="row">
                                        <div class="col col-12" :class="coluna_unica ? 'col-md-6' : 'col-md-3'" v-for="(dt, idx) in calc_datas()" :key="idx">
                                            <a href="#" @click.prevent="ver_outros_horario(dt)" class="card-link" v-if="marcacao">
                                                {{ $util.getFormatDate(dt) }}
                                            </a>

                                            <span v-else>
                                                {{ $util.getFormatDate(dt) }}
                                            </span>

                                            <span class="badge badge-secondary">
                                                {{ $util.getFormatDate(dt, 'ddd') }}
                                            </span>

                                            <span class="ml-1" v-if="dados.valid">
                                                <a href="#" @click.prevent="toggleValid(dt)" v-if="dados.valid[dt] === 'S'">
                                                    <i class="fas fa-check-circle text-success"></i>
                                                </a>
                                                <a href="#" @click.prevent="toggleValid(dt)" v-else-if="dados.valid[dt] === 'B'">
                                                    <i class="fa fa-minus-circle text-secondary"></i>
                                                </a>

                                                <!-- <a href="#" @click.prevent="ver_outros_horario(dt)" v-else-if="dados.valid[dt] === 'N'"> -->
                                                <i class="fa fa-times-circle text-danger" v-if="dados.valid[dt] === 'N'"></i>
                                                
                                                <div class="dropdown" v-if="dados.horarios && dados.horarios[dt]">
                                                    <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        {{ dados.valid_hora[dt] 
                                                            ? ( dados.valid_hora[dt].hg ? dados.valid_hora[dt].hg : dados.valid_hora[dt].hora ) 
                                                            : 'Hora' }}
                                                    </button>
                                                    <div class="dropdown-menu dropdown-menu-scroll" aria-labelledby="dropdownMenuButton">
                                                        <a class="dropdown-item" href="#" v-for="(horario_rep, ihx) in dados.horarios[dt]" :key="ihx"
                                                            @click.prevent="select_hora(dt, horario_rep)">
                                                            {{ horario_rep.hg ? horario_rep.hg : horario_rep.hora }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <pre v-if="false">{{ dados }}</pre>
                            </div>
                        </div>
                        <!--
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-primary">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
        -->
    </div>
</template>

<script>
import * as moment from 'moment';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            timeout: null, 
            validate: false, 
            valid: [],
            dados: { 
                base: this.$util.hoje(),
                hora: "", 
                fim: "em",
                intervalo: 1,
                termina_em: "",
                ocorrencias: 1, 
                dias: [
                    { nome: 'Dom', dia: 0, selecionado: false },
                    { nome: 'Seg', dia: 1, selecionado: false },
                    { nome: 'Ter', dia: 2, selecionado: false },
                    { nome: 'Qua', dia: 3, selecionado: false },
                    { nome: 'Qui', dia: 4, selecionado: false },
                    { nome: 'Sex', dia: 5, selecionado: false },
                    { nome: 'Sab', dia: 6, selecionado: false },
                ],
            }
        }
    },

    props: ['value', 'id_medico', 'coluna_unica', 'marcacao'],

    components: { 
        AzInput,
    },

    watch: { 
        dados: { 
            handler: function (newValue) {
                if ( newValue ) { 
                    newValue.datas = this.calc_datas();
                    this.validar_datas ();
                    
                    this.$emit ('input', newValue);
                }
            },
            immediate: true,
            deep: true, 
        },
    },

    computed: { 
        datas: function () { 

            return [];

            /*
            let contador = 0;
            let base = this.dados.base;
            let lista = [base];

            if ( !base )
                return [];

            if ( this.dados.fim == 'em' ) { 

                while ( base < this.dados.termina_em && contador < 1000 ) { 

                    base = moment(base, "YYYY-MM-DD").add(1,"day").format('YYYY-MM-DD');

                    if ( this.dados.dias[moment(base, "YYYY-MM-DD").weekday()].selecionado ) { 

                        if ( !(this.semana(this.dados.base, base) % this.dados.intervalo ) ) {
                            lista.push(base);
                        }

                    }

                    contador ++;

                }

                this.dados.ocorrencias = lista.length;

            } else if ( this.dados.fim == 'apos' ) { 

                let ocorrencias = this.dados.ocorrencias - 1;

                while ( ocorrencias > 0 && contador < 1000 ) { 
                    base = moment(base, "YYYY-MM-DD").add(1,"day").format('YYYY-MM-DD');

                    if ( this.dados.dias[moment(base, "YYYY-MM-DD").weekday()].selecionado ) { 
                        lista.push(base);
                        ocorrencias --;
                    }

                    contador ++;
                }

                this.dados.termina_em = base;

            }

            return lista;
            */

        },
    },

    methods: { 
        select_hora(dt, hora) { 
            this.dados.valid_hora[dt] = hora;
            this.dados.valid[dt] = 'S';
            this.$forceUpdate();
        },
        ver_outros_horario (dt) { 
            if ( this.$store.state.loading ) { 
                return;
            }

            if ( this.dados.horarios && this.dados.horarios[dt] ) { 
                return;
            }

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: "agendas.index",
                        id: "lista",
                        parms: {
                            data: dt,
                            medico: this.id_medico,
                            group: "none",
                            livres: true, // this.medico ? true : false, 
                            confirmacao: false, // this.medico ? true : false, 
                            detalhe: true, 
                            procedimento: this.marcacao.procedimento.id_procedimento,
                            plano: this.marcacao.plano.id_plano, 
                            id_paciente: this.id_paciente, 
                            cc: false, 
                            infusao: false, 
                            unidade_operacao: this.marcacao.id_unidade_operacao, 
                        }
                    }
                ]
            };

            this.axios.post("/aql?a=agendas.recorrencia", query)
                .then(res => {
                    console.log(res.data);

                    if ( !this.dados.horarios ) { 
                        this.dados.horarios = {};
                        this.dados.valid_hora = {};
                    }

                    this.dados.horarios[dt] = res.data.lista.data.agendas.filter(item => item && item.status == 'livre')
                        .map(item => { 
                            return { 
                                hora: item.hora, 
                                hg: item.hg, 
                            };
                        });

                    this.$forceUpdate();
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });

        },

        total_datas() { 
            if ( !this.dados )
                return -1;

            return _.values(this.dados.valid)
                .filter(item => { 
                    return item == 'S';
                }).length;
        },

        toggleValid(dt) { 
            this.dados.valid[dt] = this.dados.valid[dt] == 'S' ? 'B' : 'S';
            this.$forceUpdate();                
        },

        calc_datas() { 

            let contador = 0;
            let base = this.dados.base;
            let lista = [base];

            if ( !base )
                return [];

            if ( this.dados.fim == 'em' ) { 

                while ( base < this.dados.termina_em && contador < 365 ) { 

                    base = moment(base, "YYYY-MM-DD").add(1,"day").format('YYYY-MM-DD');

                    if ( this.dados.dias[moment(base, "YYYY-MM-DD").weekday()].selecionado ) { 

                        if ( !(this.semana(this.dados.base, base) % this.dados.intervalo ) ) {
                            lista.push(base);

                            if ( lista.length > 60 ) 
                                break;
                        }

                    }

                    contador ++;

                }

                this.dados.ocorrencias = lista.filter(item => { 
                    return !this.dados.valid || this.dados.valid[item] == 'S';
                }).length;

            } else if ( this.dados.fim == 'apos' ) { 

                let ocorrencias = ( this.dados.ocorrencias > 60 ? 61 : this.dados.ocorrencias - 1 );

                while ( ocorrencias > 0 && contador < 1000  ) { 
                    base = moment(base, "YYYY-MM-DD").add(1,"day").format('YYYY-MM-DD');

                    if ( this.dados.dias[moment(base, "YYYY-MM-DD").weekday()].selecionado
                        && ( !(this.semana(this.dados.base, base) % this.dados.intervalo ) ) ) { 

                        lista.push(base);

                        if ( !this.dados.valid || ( this.dados.valid[base] !== 'N' && this.dados.valid[base] !== 'B' ) ) 
                            ocorrencias --;
                        
                    }

                    contador ++;
                }

                this.dados.termina_em = base;

            }

            return lista;

        },
        semana(from, to) { 
            from = moment(from, 'YYYY-MM-DD');
            to = moment(to, 'YYYY-MM-DD');
            return to.diff(from, 'weeks');
        },

        abrir(data) { 
            this.dados.base = data;
            this.dados.dias[moment(data.substr(0,10), 'YYYY-MM-DD').weekday()].selecionado = true;
        },

        validar_datas() { 

            if ( this.dados.datas.length <= 1 || !this.id_medico )
                return;

            if (this.timeout) { 
                clearTimeout(this.timeout); 
                this.timeout = null;
            }

            this.timeout = setTimeout(() => {

                let dados = { ...this.dados };

                if ( this.marcacao && this.marcacao.hg ) { 
                    dados.hg = this.marcacao.hg;
                }

                let params;

                if ( this.marcacao ) { 
                    params = { 
                        ...dados,
                        procedimento: this.marcacao.procedimento,
                        id_unidade_operacao: this.marcacao.id_unidade_operacao, 
                        id_medico: this.id_medico, 
                        id_paciente: ( this.marcacao && this.marcacao.paciente ) ? this.marcacao.paciente.id_pessoa : null,
                    };
                } else { 
                    params = { ...dados,
                        id_unidade_operacao: ( dados.id_unidade_operacao ? dados.id_unidade_operacao.id_unidade_operacao : null ), 
                        id_medico: ( this.id_medico ? this.id_medico : ( dados.medico ? dados.medico.id_pessoa : null ) ), 
                    };
                }

                this.$util.loadItem(this, { 
                    service: 'agendas',
                    func: 'validar_recorrencia',
                    parms: { 
                        ...params
                    }
                })
                .then(res => { 
                    this.dados.valid = _.mapValues(res.valid, (item, dt) => { 
                        return ( this.dados.valid && this.dados.valid[dt] == 'B' ) ? 'B' : item;
                    });

                    this.$forceUpdate();
                });
                
            }, 300);

        }
    },
    
    mounted() { 
        if ( this.value && this.value.hora )
            this.dados.hora = this.value.hora;

        this.abrir(
            ( this.value && this.value.base ) ? this.value.base : this.$util.hoje()
        );
    }
}
</script>